<ion-select 
  [ngClass]="config?.class" 
  [interface]="interface"
  [interfaceOptions]="interfaceOptions"
  [mode]="mode" 
  [value]="config?.options[preSelectedIndex]?.value"  
  (ionChange)="onOptionChange($event)">
  <ng-template [ngIf]="config.options.length">
    <ion-select-option [ngClass]="config?.optionClass"
      *ngFor="let option of config.options"
      [value]="option.value"
      >{{option.label}}</ion-select-option
    >
  </ng-template>
</ion-select>